<template>
  <aha-modal
    width="400px"
    :title="title"
    :no-margin-padding="true"
    :visible-overflow="true"
    v-if="presentation "
    @hide="$emit('hide')"
  >
    <div class="divider" />
    <div class="p-5 pb-0 pt-0" v-if="!isEURegion">
      <slot name="item-section">
        <div class="mt-4">
          <SaveAsGoogleDriveSection v-if="!isEURegion" :presentation="presentation" />
        </div>
      </slot>
      <div class="divider mt-6 mb-6" />
    </div>
    <div class="p-5 pt-0">
      <div class="mt-4">
        <DownloadSlideSection :presentation="presentation" />
      </div>
      <slot name="info-box-section">
        <div class="mt-6 mb-6" />
        <AhaInfoBox>
          <div class="font-bold">
            <p>{{ $i18nPresenter.t('Want to see presentation result?') }}</p>
          </div>
          <div class="text-link link-redirect" @click="redirectReportPage">
            {{ $i18nPresenter.t('Click here to view report & download result') }}
          </div>
        </AhaInfoBox>
      </slot>
    </div>
  </aha-modal>
</template>
<script>
import { mapState } from 'vuex'
import utils from '@/util'
import config from '@/config'
import DownloadSlideSection from '@/components-v2/editor-share-v2/DownloadSlideSection.vue'
import SaveAsGoogleDriveSection from '@/components-v2/editor-share-v2/SaveAsGoogleDriveSection.vue'
import eventCategories from '@/constant/eventCategories'

export default {
  components: {
    DownloadSlideSection,
    SaveAsGoogleDriveSection,
  },
  data() {
    return {
      title: this.$i18nPresenter.t('Export'),
      isDownloadLastVersion: false,
    }
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
    }),
    isEURegion() {
      return config.region === 'eu'
    },
    timeExport() {
      return this.exportData.requestAt
    },
    exportData() {
      return this.presentation.exportData
    },
    linkFileDownload() {
      if (!this.exportData) return null
      const mappingExportType = {
        image: 'zipUrl',
        pdf: 'pdfUrl',
      }
      return this.exportData[mappingExportType[this.exportType]]
    },

  },
  destroyed() {
    this.isDownloadLastVersion = false
  },
  methods: {
    redirectReportPage() {
      this.$router.push({
        name: 'PresentationReport',
        params: { id: this.presentation.id },
      })
      utils.trackGA4AndMixpanel(eventCategories.PRESENTATION_EDITOR, {
        eventAction: 'Editor Header > Open results',
        eventCategory: eventCategories.PRESENTATION_EDITOR,
        ...{
          presentationId: this.presentation.id,
        },
      })
    },

  },
}

</script>
<style  lang="scss" scoped >
.title-modal-version{
  color: #282E3E;
  font-weight: 700;
  font-size: 20px;
}
.modal-close{
  svg{
    cursor: pointer;
    path {
      fill: #999999
    }
  }
}
.link-redirect{
  font-weight: 700;
  color : #348EF6;

}
.border-item{
  border: 1px solid #D3D7E1;
  border-radius: 4px;
}
.divider{
  height: 1px;
  background-color:#EBEBEB;

}
p{
  color : #282E3E;
}

</style>
